<ul
    class="ap-button-group"
    role="radiogroup"
    [attr.aria-label]="ariaLabel() ? ariaLabel() : null"
    [attr.aria-labelledby]="ariaLabelledBy() ? ariaLabelledBy() : null"
    data-testid="group"
>
    @for (buttonItem of _buttonItems(); track buttonItem; let i = $index; let isLast = $last) {
        <li class="ap-button-group__item" data-testid="item">
            <label
                class="ap-button ap-button__group-button"
                [ngClass]="{
                    'ap-button__group-button--active': value === buttonItem.value() && !isDisabled,
                    'ap-button__group-button--not-active': value && value !== buttonItem.value(),
                    'ap-button__group-button--disabled': isDisabled
                }"
                data-testid="label"
            >
                <input
                    class="ap-button--toggle-input"
                    [attr.name]="name()"
                    [name]="name()"
                    type="radio"
                    [required]="required"
                    [ngModel]="value"
                    (ngModelChange)="value = buttonItem.value()"
                    [attr.aria-disabled]="isDisabled ? isDisabled : null"
                    [value]="buttonItem.value()"
                    (click)="onButtonItemClicked(buttonItem.value())"
                    (blur)="onBlur()"
                    data-testid="input"
                />
                {{ buttonItem.label() }}
            </label>
        </li>
    }
</ul>

@if (formControl()) {
    <ap-form-errors
        data-testid="errors"
        [control]="formControl()"
        [messages]="messages()"
        [content]="content"
        [attr.id]="uniqueId + '-errors'"
    ></ap-form-errors>
}
